import React, {Fragment, useState} from 'react';
import {Button, FormHelperText, Stack, TextField, Typography} from '@mui/material';
import {useController, useFormContext} from 'react-hook-form';
import Icon from 'presentation/icons';
import {AddressDataFormValues} from '../validation';
import {HOUSE_LABEL, OTHER_LABEL, WORK_LABEL} from './constants';
import {getInitialCustomLabel, getInitialType} from './utils';
import {translations} from 'presentation/translations-new';

const {favoriteAddressFieldTitle, favoriteAddressFieldPlaceholder} =
	translations['pt-br'].privateFlow.profile.changeData.address;

export function FavoriteAddressField() {
	const {control} = useFormContext<AddressDataFormValues>();
	const {field, fieldState} = useController({
		name: 'favoriteAddress',
		control,
	});

	const [selectedType, setSelectedType] = useState<string | undefined>(() =>
		getInitialType(field.value),
	);
	const [customLabel, setCustomLabel] = useState(() => getInitialCustomLabel(field.value));

	const handleSelectFavorite = (type: string) => {
		setSelectedType(type);
		field.onChange(type === OTHER_LABEL ? customLabel || OTHER_LABEL : type);
	};

	return (
		<Fragment>
			<Stack direction="column" alignItems="flex-start" gap={2}>
				<Typography variant="button" color={'text.secondary'}>
					{favoriteAddressFieldTitle}
				</Typography>
				<Stack direction="row" alignItems="flex-start" gap={1}>
					<Button
						startIcon={<Icon name="home-filled" size={16} />}
						size="small"
						color={selectedType === HOUSE_LABEL ? 'primary' : 'inherit'}
						onClick={() => handleSelectFavorite(HOUSE_LABEL)}>
						{HOUSE_LABEL}
					</Button>
					<Button
						startIcon={<Icon name="building-outline" size={16} />}
						size="small"
						color={selectedType === WORK_LABEL ? 'primary' : 'inherit'}
						onClick={() => handleSelectFavorite(WORK_LABEL)}>
						{WORK_LABEL}
					</Button>
					<Button
						startIcon={<Icon name="location-on-filled" size={16} />}
						size="small"
						color={selectedType === OTHER_LABEL ? 'primary' : 'inherit'}
						onClick={() => handleSelectFavorite(OTHER_LABEL)}>
						{OTHER_LABEL}
					</Button>
				</Stack>
				{selectedType === OTHER_LABEL && (
					<TextField
						sx={{mt: 1}}
						slotProps={{formHelperText: {sx: {fontSize: '0.75rem'}}}}
						fullWidth
						label={favoriteAddressFieldPlaceholder}
						placeholder={favoriteAddressFieldPlaceholder}
						value={customLabel}
						onChange={e => {
							setCustomLabel(e.target.value);
							field.onChange(e.target.value || OTHER_LABEL);
						}}
					/>
				)}
				{fieldState.error ? (
					<FormHelperText error>{fieldState.error.message}</FormHelperText>
				) : null}
			</Stack>
		</Fragment>
	);
}
